/**
 *  @swagger
 *  definitions:
 *    RegattaResultOverallRegattaResultTableParams:
 *      type: object
 *      properties:
 *        RegattaResultOverallId:
 *          description: ID of the associated RegattaResultOverall
 *          type: string
 *        RegattaResultTableId:
 *          description: ID of the associated RegattaResultTable
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    RegattaResultOverallRegattaResultTableCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaResultOverallRegattaResultTableParams'
 *        - type: object
 *          required:
 *            - RegattaResultOverallId
 *            - RegattaResultTableId
 *
 *  @swagger
 *  definitions:
 *    RegattaResultOverallRegattaResultTableQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the RegattaResultOverallRegattaResultTable
 *              type: string
 *        - $ref: '#/definitions/RegattaResultOverallRegattaResultTableParams'
 *
 *  @swagger
 *  definitions:
 *    RegattaResultOverallRegattaResultTableUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaResultOverallRegattaResultTableQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    RegattaResultOverallRegattaResultTable:
 *      allOf:
 *        - $ref: '#/definitions/RegattaResultOverallRegattaResultTableCreateParams'
 *        - $ref: '#/definitions/RegattaResultOverallRegattaResultTableUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      RegattaResultOverallRegattaResultTable:
 *        allOf:
 *          - $ref: '#/definitions/RegattaResultOverallRegattaResultTable'
 *          - type: object
 *            properties:
 *              RegattaResultOverall:
 *                description: RegattaResultOverall of the RegattaResultOverallRegattaResultTable
 *                $ref: '#/components/schemas/RegattaResultOverall'
 *              RegattaResultTable:
 *                description: RegattaResultTable of the RegattaResultOverallRegattaResultTable
 *                $ref: '#/components/schemas/RegattaResultTable'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  RegattaResultOverallId: string;
  RegattaResultTableId: string;
};
export type $CreateParams = $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  RegattaResultOverall?: $Model<'RegattaResultOverall'>;
  RegattaResultTable?: $Model<'RegattaResultTable'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'RegattaResultOverallRegattaResultTable'> => {
  const RegattaResultOverallRegattaResultTable = stack.define(
    'RegattaResultOverallRegattaResultTable',
    fields(Sequelize),
    {
      tableName: 'RegattaResultOverallRegattaResultTables',
    },
  );

  RegattaResultOverallRegattaResultTable.associate = (models: $ModelClasses) => {
    models.RegattaResultOverallRegattaResultTable.belongsTo(
      models.RegattaResultOverall,
      {
        as: 'RegattaResultOverall',
        foreignKey: 'RegattaResultOverallId',
      },
    );
    models.RegattaResultOverallRegattaResultTable.belongsTo(
      models.RegattaResultTable,
      {
        as: 'RegattaResultTable',
        foreignKey: 'RegattaResultTableId',
      },
    );
  };

  return RegattaResultOverallRegattaResultTable;
});
